module.exports = __webpack_public_path__ + "static/media/xslego-4-wireframe.edd5918b.png";